import { render, staticRenderFns } from "./TourPreview.vue?vue&type=template&id=496a47e5&"
import script from "./TourPreview.vue?vue&type=script&lang=js&"
export * from "./TourPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports